<template>
  <div>
    <ul class="ul-caption">
      <li>
        <p class="title">통산기록</p>
      </li>
    </ul>
    <div class="total-year-records">
      <table>
        <thead>
        <tr>
          <td v-for="(item, index) in totalHeadList" :key="index">{{item}}</td>
        </tr>
        </thead>
        <tbody v-if="total">
        <tr>
          <td class="point">{{total.work_qty}}</td>
          <td class="point">{{total.goal_qty}}</td>
          <td class="point">{{total.assist_qty}}</td>
          <td class="point">{{total.st_qty}}</td>
          <td class="point">{{total.fo_qty}}</td>
          <td class="point">{{total.warn_qty}}</td>
          <td class="point">{{total.exit_qty}}</td>
          <td class="point">{{total.loss_goal}}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="8">데이터가 없습니다.</td>
        </tr>
        </tbody>
      </table>
    </div>
    <ul class="ul-caption pt">
      <li>
        <p class="title">시즌별기록</p>
      </li>
    </ul>
    <div class="total-year-records">
      <table>
        <thead>
        <tr>
          <td v-for="(item, index) in seasonHeadList" :key="index">{{item}}</td>
        </tr>
        </thead>
        <tbody v-if="season.length">
        <tr v-for="(item, index) in season" :key="index">
          <td>{{item.meet_year}}</td>
          <td>
            <img :src="getEmblem(item.at_time_team.split('_')[0])" alt="">
            {{item.at_time_team_name}}
          </td>
          <td>{{item.work_qty}}</td>
          <td>{{item.goal_qty}}</td>
          <td>{{item.assist_qty}}</td>
          <td>{{item.st_qty}}</td>
          <td>{{item.fo_qty}}</td>
          <td>{{item.warn_qty}}</td>
          <td>{{item.exit_qty}}</td>
          <td>{{item.loss_goal}}</td>
        </tr>
        </tbody>
        <tbody v-else>
        <tr>
          <td colspan="10">데이터가 없습니다.</td>
        </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import {getEmblem} from '@/lib';

export default {
  name: 'TotalYearlyRecords',
  props: {
    total: {
      type: Object,
      default: () => {}
    },
    season: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    total: {
      handler: function () {
        // console.log('total ', this.total);
      }
    },
    season: {
      handler: function () {
        // console.log('season ', this.season);
      }
    }
  },
  data() {
    return {
      totalHeadList: ['출장', '득점', '도움', '슈팅', '파울', '경고',  '퇴장', '실점'],
      seasonHeadList: ['시즌', '소속팀', '출장', '득점', '도움', '슈팅', '파울', '경고',  '퇴장', '실점'],
      // totalList: [],
      // seasonList: []
    }
  },
  mounted () {

    // this.getRecordList();
  },
  methods: {
    getEmblem,
    getRecordList() {

    }
  }
}
</script>
